import React from "react";

export const IconButton = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="20"
            height="14"
            viewBox="0 0 20 14"
        >
            <defs>
                <clipPath id="clip-path">
                    <rect width="20" height="14" fill="none" />
                </clipPath>
            </defs>
            <g
                id="Symbol_5_1"
                data-name="Symbol 5 – 1"
                transform="translate(0 0)"
                clipPath="url(#clip-path)"
            >
                <path
                    id="Path_393"
                    data-name="Path 393"
                    d="M18,13.1H2A1.1,1.1,0,0,1,.9,12V2A1.1,1.1,0,0,1,2,.9H18A1.1,1.1,0,0,1,19.1,2V12A1.1,1.1,0,0,1,18,13.1Z"
                    transform="translate(0 0)"
                    fill="#fff"
                    stroke="currentColor"
                    strokeWidth="1.8"
                />
                <path
                    id="Path_356"
                    data-name="Path 356"
                    d="M0,0H10.971"
                    transform="translate(4.5 7.5)"
                    fill="#fff"
                    stroke="currentColor"
                    strokeWidth="1.8"
                />
            </g>
        </svg>
    );
};
